import { Controller } from "@hotwired/stimulus";

// Le contrôleur du message d'état — `data-controller="notification"`.
//
// 🔴 **CE FICHIER NE CONTIENT PLUS QUE LA CLASSE STIMULUS — 2026-09-21, et c'est
// une décision de BUDGET, mesurée.**
//
// Il portait aussi l'usine `window.Notify` / `window.Toast` : 1 613 des 2 028
// octets gzippés du fichier, dont cinq SVG recopiés en ligne. GO4LEARN a dû
// enregistrer ce contrôleur le jour où il est passé au message de la suite —
// sans lui, le bouton « fermer » ne fermait rien — et le cliquet `learn-budget`
// a mesuré **+1 597 octets** sur le paquet d'un enfant sur 3G, pour une usine
// qu'aucune vue apprenante n'appelle. Les appelants de `window.Notify` sont tous
// côté GO4SCHOOL : `school_setting`, `job_status`, `online_payment`,
// `dsf_generation_progress`.
//
// L'usine vit désormais dans `app/javascript/utils/notify.js`, importée par le
// seul `application.js`. Le contrôleur coûte **515 octets gz**.
//
// ⚠️ **L'entrée du message ne dépend PAS de ce contrôleur** : `shared/_notification`
// entre par l'animation CSS `.flash-enter` (voir `entrypoints/application.css`).
// `connect()` ci-dessous retire encore `translate-x-full opacity-0` — ces classes
// ne sont plus posées par le serveur, mais elles le sont par l'usine, et retirer
// une classe absente ne fait rien. Ce contrôleur n'ajoute que l'auto-masquage et
// la fermeture : de l'amélioration progressive, jamais une dépendance.
export default class extends Controller {
  static values = {
    type: { type: String, default: "info" },
    duration: { type: Number, default: 5000 },
    autoHide: { type: Boolean, default: true },
  };

  connect() {
    // Slide in from the right
    requestAnimationFrame(() => {
      this.element.classList.remove("translate-x-full", "opacity-0");
      this.element.classList.add("translate-x-0", "opacity-100");
    });

    if (this.autoHideValue && this.durationValue > 0) {
      this.timeout = setTimeout(() => this.hide(), this.durationValue);
    }
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }

  hide() {
    // Slide out to the right + fade
    this.element.classList.remove("translate-x-0", "opacity-100");
    this.element.classList.add("translate-x-full", "opacity-0");

    setTimeout(() => {
      if (this.element.parentElement) this.element.remove();
    }, 300);
  }

  close() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    this.hide();
  }
}
